import type { SystemStyleObject } from "styled-system/types";

export const root: SystemStyleObject = {
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};

export const header: SystemStyleObject = {
  padding: "md",
  borderBottomWidth: "1px",
  borderBottomStyle: "solid",
  borderBottomColor: "color-mix(in srgb, currentColor, transparent 90%)",
};

export const body: SystemStyleObject = {
  padding: "md",
  flex: 1,
};

export const footer: SystemStyleObject = {
  padding: "md",
  borderTopWidth: "1px",
  borderTopStyle: "solid",
  borderTopColor: "color-mix(in srgb, currentColor, transparent 90%)",
};

export const interactive: SystemStyleObject = {
  cursor: "pointer",
  transition: "transform 0.2s, border-color 0.2s, box-shadow 0.2s",
  _hover: {
    transform: "translateY(-2px)",
    borderColor: "primary",
    boxShadow: "0 10px 15px -3px rgb(0 0 0 / 0.1)",
  },
};
